import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// Styles
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Main from "./components/layout/Main";
import Loader from "./components/spinner/Spinner";
import ProtectedRoute from "./components/routes/ProtectedRoutes";



const Home = lazy(() => import("./pages/Home"));
const Profile = lazy(() => import("./pages/Profile"));
const AuthCustomer = lazy(() => import("./pages/auth/AuthCustomer"));
const AuthComponent = lazy(() => import("./components/layout/Auth"));
const ChooseOption = lazy(() => import("./pages/auth/ChooseAuthOption"));
const Users = lazy(() => import("./pages/users/main"));
const MicrosoftAuth = lazy(() => import("./pages/auth/microsoftauth"));
const Onboarding = lazy(() => import("./pages/onboarding/onboarding"));
const Verify = lazy(() => import("./pages/onboarding/verify"));
const SMS = lazy(() => import("./pages/sms/main"));
const Notifications = lazy(() => import("./pages/notifications/notifications"));
const NotificationRequests = lazy(() => import("./pages/notifications/notification-requests"));
const Recon = lazy(() => import("./pages/recon/main"));



function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Navigate to="/auth/login" />} />

        {/* Authentication Routes */}
        <Route path="/auth" element={<AuthComponent />}>
          <Route path="login" element={<ChooseOption />} />
          <Route path="staff" element={<AuthCustomer />} />
          <Route path="microsoftauth" element={<MicrosoftAuth />} />
        </Route>

        {/* Routes within Main layout */}
        <Route path="/" element={<Main />}>
          <Route
            path="dashboard"
            element={
              <ProtectedRoute allowedRoles={['STAFFMAKER', 'STAFFCHECKER', 'ADMIN', 'CUSTOMER_SUPPORT', 'RECON']}>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="notifications"
            element={
              <ProtectedRoute allowedRoles={['STAFFMAKER', 'ADMIN', 'CUSTOMER_SUPPORT']}>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="notification-requests"
            element={
              <ProtectedRoute allowedRoles={['STAFFMAKER', 'CUSTOMER_SUPPORT']}>
                <NotificationRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="onboarding"
            element={
              <ProtectedRoute allowedRoles={['STAFFMAKER']}>
                <Onboarding />
              </ProtectedRoute>
            }
          />
          <Route
            path="billers"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <Onboarding />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <Users />
              </ProtectedRoute>
            }
          />
           <Route
            path="sms"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <SMS />
              </ProtectedRoute>
            }
          />
          <Route
            path="my-actions"
            element={
              <ProtectedRoute allowedRoles={['STAFFCHECKER']}>
                <Verify />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile"
            element={
              <ProtectedRoute allowedRoles={['STAFFMAKER', 'STAFFCHECKER', 'ADMIN', 'CUSTOMER_SUPPORT', 'RECON']}>
                <Profile />
              </ProtectedRoute>
            }
          />


          <Route
            path="reconcile"
            element={
              <ProtectedRoute allowedRoles={['RECON']}>
                <Recon />
              </ProtectedRoute>
            }
          />
          
          <Route path="*" element={<Navigate to="/auth/login" />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
